/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_ATTENDEES (state, attendees) {
    state.attendees = attendees
  },
  SET_ATTENDEESMAPPING (state, attendeesmapping) {
    state.attendeesmapping = attendeesmapping
  },
  REMOVE_RECORD (state, itemId) {
    const attendeeIndex = state.attendees.findIndex((u) => u.Email === itemId)
    state.attendees.splice(attendeeIndex, 1)
  }
}
